import { useCallback } from "react";
import Particles from "react-particles";
import { loadSlim } from "tsparticles-slim";

const ParticlesBackground = () => {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: -1, // Ensure it stays behind other content
    }}>
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          particles: {
            number: {
              value: 200,
              density: {
                enable: true,
                value_area: 750,
              },
            },
            color: {
              value: "var(--Brand-Gradient, linear-gradient(90deg, #E5542F 0%, #8431D6 100%))", // Blue dots
            },
            links: {
              enable: true,
              color: "#BF4771", // Default gray color
              distance: 120,
              opacity: 0.12,
              width: 2,
            },
            move: {
              enable: true,
              speed: 0.5,
            },
            size: {
              value: 2,
            },
            opacity: {
              value: 0.9,
            },
          },
          interactivity: {
            events: {
              onHover: {
                enable: true,
                mode: "connect", // Enables color change on hover
              },
            },
            modes: {
              connect: {
                distance: 10,
                links: {
                  opacity: 0.6,
                  color: "rgba(94,77,224,1)", // Changes link color on hover
                },
              },
            },
          }
        }}
      />
    </div>
  );
};

export default ParticlesBackground;